import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResetPasswordComponent } from './account/reset-password/reset-password.component';
import { ResetPasswordSentEmailComponent } from './account/reset-password-sent-email/reset-password-sent-email.component';
import { ResetPasswordSuccessComponent } from './account/reset-password-success/reset-password-success.component';
import { SetNewPasswordComponent } from './account/set-new-password/set-new-password.component';
import { EmailGuard, ProdGuard } from './state/app.guards';
import { EnvConfigComponent } from './env-config/env-config.component';
import { ErrorComponent } from './account/error/error.component';
import { UpdateComponent } from './update/update.component';


export const routes: Routes = [


  {
    path: 'account/reset-password',
    component: ResetPasswordComponent,
    canActivate: [],
    data: { title: 'Reset your password', animation: 'ResetPassword', showBackButton: false },
  },
  {
    path: 'account/reset-password/sent-email',
    component: ResetPasswordSentEmailComponent,
    canActivate: [],
    data: { title: 'Reset password email sent', animation: 'ResetPasswordSentEmail', showBackButton: false },
  },
  {
    path: 'account/reset-password/success',
    component: ResetPasswordSuccessComponent,
    canActivate: [],
    data: { title: 'Reset your password', animation: 'ResetPasswordSuccess', showBackButton: false },
  },
  { path: 'env', component: EnvConfigComponent, canActivate: [ProdGuard] },

  { path: 'error', component: ErrorComponent, data: { title: 'Error', showBackButton: false } },

  { path: '', redirectTo: 'error', pathMatch: 'full' },
  { path: '**', redirectTo: 'error', pathMatch: 'full' },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
